import React from 'react';
import Page from '../lib/page';
import i18n from '../lib/reacti18n';

const links = {
  smartHelpHome: Page.getHomeURL(),
};

const HelpHeading = i18n.message('smarthelp/heroSection.heroLinks.helpcenter.largeScreen');

const NewHeroModuleSession = function (args) {
  return (
    <div className="home-hero-selection-hcr">
      <div className="hero-selection-hcr-link">
        <a href={links.smartHelpHome} className="hero-selection-heading">
          {HelpHeading}
        </a>
      </div>
      {args.children}
    </div>
  );
};

export default NewHeroModuleSession;
